import { useEffect, useState } from "react"

/**
 * Custom React hook to track and monitor the current screen dimensions
 *
 * This hook provides real-time screen size information by tracking the browser's
 * window dimensions. It automatically updates when the window is resized and
 * provides fallback values for server-side rendering environments.
 *
 * @returns {Object} screenSize - Object containing current screen dimensions
 * @returns {number} screenSize.width - Current window width in pixels (default: 1200)
 * @returns {number} screenSize.height - Current window height in pixels (default: 800)
 */
export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: typeof window !== "undefined" ? window.innerWidth : 1200,
    height: typeof window !== "undefined" ? window.innerHeight : 800,
  })

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return screenSize
}
